import React, { useState, useEffect } from 'react';
import { db, collection, getDocs, addDoc, deleteDoc, updateDoc, doc } from '../firebase';
import { Container, Grid, Card, CardContent, CardMedia, Typography, Button, Box, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../AuthContext';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';


const ManageItems = () => {
  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');
  const [subcategory1, setSubcategory1] = useState('');
  const [subcategory2, setSubcategory2] = useState('');
  // const [subsubcategory, setSubsubcategory] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [image, setImage] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    const itemsCollection = await getDocs(collection(db, 'items'));
    const itemsData = itemsCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setItems(itemsData);
  };

  const handleClickOpen = (item) => {
    setSelectedItem(item);
    setName(item.name || '');
    setCategory(item.category || '');
    setSubcategory1(item.subcategory1 || '');
    setSubcategory2(item.subcategory2 || '');
    // setSubsubcategory(item.subsubcategory || '');
    setSerialNumber(item.serialNumber || '');
    setImage(item.image || '');
    setOpen(true);
  };


  const renameKeys = (array, keyMap) => {
    array.forEach(obj => {
      for (const oldKey in keyMap) {
        if (obj.hasOwnProperty(oldKey)) {
          const newKey = keyMap[oldKey];
          obj[newKey] = obj[oldKey];
          delete obj[oldKey];
        }
      }
    });
  };

  const keyMap = {
    category: "קטגוריה",
    id: "מספר סידורי בבסיס נתונים",
    image: "תמונה",
    name: "שם מוצר",
    serialNumber: "מק''ט",
    subcategory1: "תת קטגוריה",
    subcategory2: "תיאור"
  };

  const downloadExcel = () => {
    let exData = items;
    renameKeys(exData, keyMap);
    const worksheet = XLSX.utils.json_to_sheet(exData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Items');
    XLSX.writeFile(workbook, 'items.xlsx');
  };

  const downloadExcel1 = () => {
    navigate('/pdf');
  };


  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  const handleSave = async () => {
    try {
      if (selectedItem && selectedItem.id) {
        const itemDoc = doc(db, 'items', selectedItem.id);
        await updateDoc(itemDoc, {
          name,
          category,
          subcategory1,
          subcategory2,
          // subsubcategory,
          serialNumber,
          image,
        });
      } else {
        await addDoc(collection(db, 'items'), {
          name,
          category,
          subcategory1,
          subcategory2,
          // subsubcategory,
          serialNumber,
          image,
        });
      }
      fetchItems();
      handleClose();
    } catch (error) {
      console.error("Error saving item: ", error);
    }
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, 'items', id));
    fetchItems();
  };


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredItems = items.filter(item =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.serialNumber.toLowerCase().includes(searchQuery.toLowerCase())
  );
  return (
    <Container sx={{ paddingTop: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
      <Box sx={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between' }}>
        <Button sx={{margin:'3px'}} variant="contained" color="primary" onClick={downloadExcel}>הוצאת פריטים לאקסל</Button>
        <Button sx={{margin:'3px'}} variant="contained" color="primary" onClick={downloadExcel1}>לניהול הסכמים והתקשרויות</Button>

        {/* <Button variant="contained" color="secondary" onClick={downloadTextFile}>Download as Text</Button> */}
      </Box>
      <TextField
        label="Search by Name or Serial Number"
        variant="outlined"
        fullWidth
        value={searchQuery}
        onChange={handleSearchChange}
        sx={{ marginBottom: '20px' }}
      />
      <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <Grid container spacing={2} alignItems="center">
//           {filteredItems.map(item => (
          <Grid item xs={6} sm={4} md={2} key={item.id}>
            <Card sx={{ width: '100px', height: '100px', backgroundColor: '#fff', color: '#333', border: '1px solid #ddd', borderRadius: '50%', overflow: 'hidden', textAlign: 'center', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', position: 'relative', margin: '0 auto' }}>
              <CardMedia
                component="img"
                alt={item.name}
                image={item.image}
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                onClick={() => handleClickOpen(item)}
              />
              <CardContent sx={{ position: 'absolute', bottom: 0, width: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', color: '#fff', padding: '2px 0' }}>
                <Typography variant="body2" sx={{ fontSize: '10px' }}>{item.serialNumber}</Typography>
              </CardContent>
            </Card>
            <Button variant="contained" color="primary" size="small" onClick={() => handleClickOpen(item)} sx={{ marginTop: '10px', marginRight: '5px', marginLeft: '5px' }}>Edit</Button>
            <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(item.id)} sx={{ marginTop: '10px' }}>Delete</Button>
          </Grid>
        ))}
        </Grid>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          {selectedItem ? 'Edit Item' : 'Add Item'}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ marginBottom: '20px' }}
          />
          <TextField
            margin="dense"
            label="Category"
            type="text"
            fullWidth
            variant="outlined"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            sx={{ marginBottom: '20px' }}
          />
          <TextField
            margin="dense"
            label="Subcategory 1"
            type="text"
            fullWidth
            variant="outlined"
            value={subcategory1}
            onChange={(e) => setSubcategory1(e.target.value)}
            sx={{ marginBottom: '20px' }}
          />
          <TextField
            margin="dense"
            label="Subcategory 2"
            type="text"
            fullWidth
            variant="outlined"
            value={subcategory2}
            onChange={(e) => setSubcategory2(e.target.value)}
            sx={{ marginBottom: '20px' }}
          />
          {/* <TextField
            margin="dense"
            label="Subsubcategory"
            type="text"
            fullWidth
            variant="outlined"
            value={subsubcategory}
            onChange={(e) => setSubsubcategory(e.target.value)}
            sx={{ marginBottom: '20px' }}
          /> */}
          <TextField
            margin="dense"
            label="Serial Number"
            type="text"
            fullWidth
            variant="outlined"
            value={serialNumber}
            onChange={(e) => setSerialNumber(e.target.value)}
            sx={{ marginBottom: '20px' }}
          />
          <TextField
            margin="dense"
            label="Image URL"
            type="text"
            fullWidth
            variant="outlined"
            value={image}
            onChange={(e) => setImage(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">Cancel</Button>
          <Button onClick={handleSave} color="primary">Save</Button>
        </DialogActions>
      </Dialog>
      <Button variant="contained" color="primary" onClick={() => handleClickOpen({})} sx={{ marginTop: '20px', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>Add Item</Button>
    </Container>
  );
};

export default ManageItems;

